import React, { useContext, useState, useEffect, useRef } from 'react';
import {
  DashboardHeader,
  CampaignDetailsHeader,
  Button,
  HelpPdfDownload,
  ActionLink,
} from '../../atoms';
import { default as t } from '../../../utils/i18n';
import Plotly from 'plotly.js-dist-min';
import { DashContentFooter, RecommendationDetailsModal } from '../../molecules';
import { AnalysisService, DashService } from '../../../services';
import { UserContext, DashboardContext } from '../../../context';
import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Tab from '@material-ui/core/Tab';
import html2canvas from 'html2canvas';
import jsPdf from 'jspdf';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import { ReactComponent as DownloadIcon } from '../../../assets/svg/Download-icon.svg';
import queryString from 'query-string';
import config from '../../../utils/config';

import './recommendation-results.scss';
import ModalWindow from '../../atoms/modal-window/modal-window';

const RecommendationResults = props => {
  const [dashData, setDashData] = useState({});
  const { user } = useContext(UserContext);
  const [campaignDetails, setCampaignDetails] = useState([]);
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;
  const history = useHistory();
  const location = queryString?.parse(window.location.search);
  const campaignId = location?.id || '23851955790160275';
  const kpiSysId = location?.sys_id || 'perf_ad_landing_page_views';

  // const campaignId = '23852387561170169070';
  // location.campaignId;

  const [tabValue, setTabValue] = useState('1');
  const [dateTabValue, setDateTabValue] = useState('1');
  const [kpiDateArray, setKpiDateArray] = useState([]);
  const [selectedKpi, setSelectedKpi] = useState([], []);
  const [insightData, setInsightData] = useState([]);
  const [kpiList, setKpiList] = useState([]);
  const kpiResponse = useRef([]);
  const [recommendationModalView, setRecommendationModalView] = useState(null);
  const [showDeleteCampaignModal, setShowDeleteCampaignModal] = useState(false);
  const [modalDetails, setModalDetails] = useState([]);
  const [showViewMoremodal, setShowViewMoremodal] = useState(false);
  const [viewMoreData, setViewMoreData] = useState(false);
  const [nonAttributes, setNonAttributes] = useState([]);
  const [showNonAttributes, setShowNonAttributes] = useState([]);
  const KPI_LABEL = useRef([]);
  const updated_selected_kpi = useRef(null);
  const Y_AXIS_LABEL = useRef(null);
  const POINT_INDEX = useRef(null);

  const FB_AD_MANAGER_URL_PREFIX = config.get('help', 'fb_ad_manager_url_prefix');

  useEffect(() => {
    getKpiList();
    getCampaignDetails();
    getCampaignAttr();
  }, []);

  const handleBackClick = e => {
    history.push('/optimization');
  };

  const handleGenerateKpikClick = e => {
    history.push(`/kpi-optimization?id=${campaignId}&sys_id=${selectedKpi}`);
  };

  const handleDownloadSSClick = () => {
    const icon = document.querySelector('.download-icon');
    icon.classList.add('active');

    var testdiv = document.getElementById('snapshot-result-container');
    html2canvas(testdiv, {
      scrollX: -window.scrollX,
      scrollY: -window.scrollY,
      windowWidth: document.documentElement.offsetWidth,
      windowHeight: document.documentElement.offsetHeight, // There is no deviation from the top so there is no need to modify
      backgroundColor: 'white',
      allowTaint: true,
      useCORS: true,
    }).then(canvas => {
      const image = canvas.toDataURL('image/jpeg', 1.0);
      const doc = new jsPdf('p', 'px', 'a4');
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      const widthRatio = pageWidth / canvas.width;
      const heightRatio = pageHeight / canvas.height;
      const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

      const canvasWidth = canvas.width * ratio;
      const canvasHeight = canvas.height * ratio;

      const marginX = (pageWidth - canvasWidth) / 2;
      const marginY = (pageHeight - canvasHeight) / 2;

      doc.addImage(image, 'JPEG', marginX, marginY, canvasWidth, canvasHeight);
      doc.save(`result-graph.pdf`);
      icon.classList.remove('active');
    });
  };

  const handleChange = (event, newValue) => {
    Y_AXIS_LABEL.current =
      event?.target?.firstChild?.data ||
      KPI_LABEL.current
        .filter(kpi => kpi.sys_id.includes(kpiSysId))
        .map(metric => metric.KPI_Metric)[0];
    let kpi = event?.target?.firstChild?.textContent;
    kpi = kpi?.indexOf(' (') > 1 ? kpi?.substring(0, kpi?.indexOf(' (')) : kpi;
    //event?.target?.firstChild?.innerText.substring(0, event.target.firstChild.innerText.indexOf(' ('));

    kpi = KPI_LABEL?.current
      ?.filter(item => item.KPI_Metric.includes(kpi))
      .map(sys => sys.sys_id)[0];

    kpi = kpi ? kpi : kpiSysId;

    setSelectedKpi(kpi);
    updated_selected_kpi.current = kpi;
    newValue = newValue.toString();
    setTabValue(Number(newValue));
    dateExtract(kpi.toLowerCase());
    handleDateChange(event, '1');
  };

  const handleDateChange = (event, newValue) => {
    let indexValue = Number(newValue) - 1;
    setDateTabValue(Number(newValue));
    let res = kpiResponse.current?.anaysis[updated_selected_kpi.current][indexValue]?.analysisId;
    getKpiInsightDetails(res);

    updateNonAttributesLabel(showNonAttributes);
  };

  const goToFbSuite = () => {
    const link = `${FB_AD_MANAGER_URL_PREFIX}campaigns?act=${campaignDetails.account_id}&selected_campaign_ids=${campaignId}&business_id=${campaignDetails?.businessAccountId}&nav_source=no_referrer`;
    window.open(link, '_blank');
  };

  const handleViewClick = (e, kpi, modalDetails) => {
    let effective = KPI_LABEL.current
      .filter(kpi => kpi.KPI_type.includes('Effectiveness'))
      .filter(x => x.sys_id.includes(insightData?.kpi));
    setRecommendationModalView({
      campaign_Details: e,
      selected_kpi: kpi,
      insight_details: modalDetails,
      kpiUnit: effective,
    });
  };

  const handleModalBackClick = e => {
    setRecommendationModalView(null);
  };

  const handleOnCloseModal = () => {
    setShowViewMoremodal(false);
    setViewMoreData(false);
  };

  async function getCampaignDetails() {
    try {
      const campaignDetailsResponse = await AnalysisService.getCampaignDetails(
        userAccessToken,
        username,
        campaignId
      );
      const campaignDetailsResp = campaignDetailsResponse.data?.data;
      campaignDetailsResp.start_time = updateDateFormatCampaign(campaignDetailsResp.start_time);
      campaignDetailsResp.stop_time = updateDateFormatCampaign(campaignDetailsResp.stop_time);
      campaignDetailsResp.budget =
        campaignDetailsResp?.budget === 'Not Set'
          ? campaignDetailsResp?.budget
          : nFormatter(campaignDetailsResp?.budget, 1) +
            '(' +
            capitalizeFirstLetter(campaignDetailsResp?.budget_mode) +
            ')';
      setCampaignDetails(campaignDetailsResp);
      getKpiDetails(campaignId);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  }

  const updateDateFormatCampaign = val => {
    const d = new Date(val);
    d.setUTCHours(0, 0, 0, 0);
    const yyyy = d.getFullYear();
    let mm = d.getMonth() + 1;
    let dd = d.getDate();
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    return dd + '/' + mm + '/' + yyyy;
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const nFormatter = (num, digits) => {
    const lookup = [
      { value: 1, symbol: '' },
      { value: 1e3, symbol: 'K' },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup
      .slice()
      .reverse()
      .find(item => {
        return num >= item.value;
      });
    return item ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : '0';
  };

  let kpiResponses = [];
  async function getKpiDetails(campaignId) {
    try {
      const kpiDetailsResponse = await AnalysisService.getKpiDetails(
        userAccessToken,
        username,
        campaignId
      );
      const kpiDetailsResp = kpiDetailsResponse.data?.data;
      kpiResponse.current = kpiDetailsResp;
      // setKpiResponse(kpiDetailsResp);
      kpiResponses = kpiDetailsResp;

      // To populate KPI Tabs intial page load
      const temp = [];
      const kpiTemp = [];
      for (const key in kpiDetailsResp.anaysis) {
        const metric = KPI_LABEL.current
          .filter(kpi => kpi.sys_id.includes(key))
          .map(metric => metric.KPI_Metric)
          .toString();
        temp.push([key, kpiDetailsResp.anaysis[key].length]);
        kpiTemp.push([metric, kpiDetailsResp.anaysis[key].length]);
        setKpiList(kpiTemp);
      }

      if (kpiSysId) {
        // Y_AXIS_LABEL.current = KPI_LABEL.current.filter(kpi => kpi.sys_id.includes(kpiSysId)).map(metric => metric.KPI_Metric).toString();
        setSelectedKpi(kpiSysId);
        let index = temp?.findIndex(arr => arr.includes(kpiSysId));
        handleChange(kpiSysId, index + 1);
        // handleDateChange(kpiSysId, '1');
      } else {
        setSelectedKpi(temp[0][0]);
        // To populate KPI date tabs initial page load
        const tempDate = [];
        tempDate.push(kpiDetailsResp?.anaysis[temp[0][0]].map(x => x.createdAt));
        let arr = tempDate[0].map(x => {
          return updateDateFormat(x);
        });
        setKpiDateArray(arr);

        // Initial insight data for graph
        let res = kpiDetailsResp?.anaysis[temp[0][0]][0]?.analysisId;
        getKpiInsightDetails(res);
      }
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  }

  async function getKpiInsightDetails(analysisId) {
    try {
      const kpiInsightResponse = await AnalysisService.getKpiInsight(
        userAccessToken,
        username,
        analysisId
      );
      let kpiInsightResp = kpiInsightResponse.data?.data;
      setInsightData(kpiInsightResp);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  }

  async function getKpiList() {
    try {
      const kpiListResponse = await DashService.kpiList(userAccessToken, username, true);
      const kpiList = kpiListResponse.data?.data;
      const checkedList = [...kpiList];
      KPI_LABEL.current = checkedList;
      setDashData(prevDashData => ({
        ...prevDashData,
        kpiList: [...kpiList],
      }));
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  }

  async function getCampaignAttr() {
    try {
      const campaignAttrResponse = await DashService.strategicAttrList(userAccessToken, username);
      const attrList = campaignAttrResponse.data?.data;
      const campaignAttrList = [...attrList];
      setNonAttributes(campaignAttrList);
    } catch (error) {}
  }

  const dateExtract = kpi => {
    const temp = [];
    temp.push(
      kpiResponse.current.anaysis
        ? kpiResponse.current.anaysis[kpi].map(x => x.createdAt)
        : kpiResponses.anaysis[kpi].map(x => x.createdAt)
    );
    let arr = temp[0].map(x => {
      return updateDateFormat(x);
    });
    setKpiDateArray(arr);
  };

  var removeByAttr = function (arr, attr, value) {
    var i = arr.length;
    while (i--) {
      if (arr[i] && arr[i].hasOwnProperty(attr) && arguments.length > 2 && arr[i][attr] === value) {
        arr.splice(i, 1);
      }
    }
    return arr;
  };

  var selectorOptions = {
    buttons: [
      {
        step: 'day',
        stepmode: 'backward',
        count: 7,
        label: t('rec.one.week'),
      },
      {
        step: 'month',
        stepmode: 'backward',
        count: 1,
        label: t('rec.one.month'),
      },
      {
        step: 'day',
        stepmode: 'backward',
        count: 42,
        label: t('rec.six.week'),
      },

      {
        step: 'month',
        stepmode: 'backward',
        count: 3,
        label: t('rec.twelve.week'),
      },
      {
        step: 'year',
        stepmode: 'todate',
        count: 1,
        label: t('rec.YTD'),
      },
      {
        step: 'year',
        stepmode: 'backward',
        count: 1,
        label: t('rec.one.year'),
        //  visible:false
      },
      {
        step: 'all',
        label: t('rec.all'),
      },
    ],
  };
  let greyArea = [];
  let upperLine, lowerLine;
  if (insightData.graphData) {
    greyArea = [...insightData?.graphData?.xAxis];
    let xReverse = greyArea.map(greyArea.pop, [...greyArea]);
    greyArea = [...greyArea, ...xReverse];

    let upperBand1 = [];
    let upperBand2 = [];
    let lowerBand1 = [];
    let lowerBand2 = [];
    for (let i = 0; i < insightData?.graphData?.yAxis.length; i++) {
      upperBand1.push(insightData.optimizationSuggestions.rawData.optimization_upper_line);
      lowerBand1.push(insightData.optimizationSuggestions.rawData.no_optimization_upper_line);
    }
    for (let i = 0; i < insightData?.graphData?.yAxis.length; i++) {
      upperBand2.push(insightData.optimizationSuggestions.rawData.optimization_lower_line);
      lowerBand2.push(insightData.optimizationSuggestions.rawData.no_optimization_lower_line);
    }
    upperLine = [...upperBand1, ...upperBand2];
    lowerLine = [...lowerBand1, ...lowerBand2];
  }

  function prepData() {
    var x = insightData?.graphData?.xAxis;
    var y = insightData?.graphData?.yAxis;
    var fixy1 = [];
    var fixy2 = [];
    let noOptimization = insightData.optimizationSuggestions.rawData.no_optimization_prediction;
    let optimization = insightData.optimizationSuggestions.rawData.optimization_prediction;
    var dt = 0;
    var yval = 5;
    while (dt < y.length) {
      fixy1.push(optimization);
      fixy2.push(noOptimization);
      dt = dt + 1;
    }

    var trace5 = {
      x: greyArea,
      y: upperLine,
      fill: 'tozeroy',
      fillcolor: 'rgba(225, 190, 106, 0.6)',
      line: { color: 'transparent' },
      name: 'DS',
      showlegend: false,
      type: 'scatter',
    };

    var trace6 = {
      x: greyArea,
      y: lowerLine,
      fill: 'tozeroy',
      fillcolor: 'rgba(64, 176, 166, 0.6)',
      line: { color: 'transparent' },
      name: 'DS',
      showlegend: false,
      type: 'scatter',
    };

    var trace4 = {
      x: x,
      y: fixy1,
      mode: 'lines',
      name:
        'Predicted lifetime KPI<br>' +
        'with optimization' +
        '(' +
        `${decimalCount(optimization)}` +
        ')',
      // name: `${optimization ? 'Predicted lifetime KPI<br>' + 'with optimization (' + optimization?.toFixed(10) + ')' : ''}`,
      showlegend: optimization ? true : false,
      line: {
        dash: 'dot',
        width: 3,
        color: '#000000',
      },
      hovertemplate:
        'Predicted lifetime KPI<br>' +
        'with optimization' +
        '(' +
        `${decimalCount(optimization)}` +
        ')',
    };
    var trace3 = {
      x: x,
      y: fixy2,
      mode: 'lines',
      name:
        'Predicted lifetime KPI<br>' +
        'with no optimization' +
        '(' +
        `${decimalCount(noOptimization)}` +
        ')',
      // name: `${noOptimization ? 'Predicted lifetime KPI<br>' + 'with optimization (' + noOptimization?.toFixed(10) + ')' : ''}`,
      showlegend: noOptimization ? true : false,
      line: {
        dash: 'dot',
        width: 2,
        color: 'grey',
      },
      hovertemplate:
        'Predicted lifetime KPI<br>' +
        'with no optimization' +
        '(' +
        `${decimalCount(noOptimization)}` +
        ')',
    };

    var trace2 = {
      y: insightData?.graphData?.metaDataChanges.y,
      x: insightData?.graphData?.metaDataChanges.x,
      mode: 'markers',
      //name: 'Metadata changes',
      //text: ['Effective status	From CAMPAIGN_PAUSED-To IN_PROCESS </BR> Targeting - Geo locations - Zips - 312 - Key	From US:44050-To US:44046 </BR> Targeting - Geo locations - Zips - 312 - Name	From 44050-To 44046 </BR> Targeting - Geo locations - Zips - 312 - Primary city id From 2500282-To 2500062', 'Targeting - Geo locations - Zips - 313 - Key	From US:44052-To US:44050 </BR> Targeting - Geo locations - Zips - 313 - Name	From 44052-To 44050 </BR> Targeting - Geo locations - Zips - 313 - Primary city id	From 2500472-To 2500282', 'Targeting - Geo locations - Zips - 314 - Key From US:44053-To US:44052 </BR>Targeting - Geo locations - Zips - 314 - Name	From 44053-To 44052', 'Targeting / Custom audiences / 0 / Id	: Removed </BR>Targeting / Custom audiences / 0 / Name	Removed ', 'Targeting / Flexible spec / 0 / Family statuses / 0 / Id	: Added as 6002714398372 </BR> Targeting / Flexible spec / 0 / Family statuses / 0 / Name	: Added as Parents (All)</BR> Targeting / Flexible spec / 0 / Family statuses / 0 / Id	: Added as 6002714398372 </BR> Targeting / Flexible spec / 0 / Family statuses / 0 / Name	: Added as Parents (All) </BR> Targeting / Flexible spec / 0 / Family statuses / 0 / Id	: Added as 6002714398372 </BR> Targeting / Flexible spec / 0 / Family statuses / 0 / Name	: Added as Parents (All)'],
      line: { shape: 'spline', color: '#132874' },
      type: 'scatter',
      marker: {
        symbol: 'circle',
        size: 10,
        color: ['black'],
      },
      showlegend: false,
      hoverlabel: {
        bgcolor: '#D3D3D3',
      },
      layout: {
        dragmode: 'zoom',
      },
      hovertemplate:
        '%{yaxis.title.text}: %{y:.10f}<br>' +
        '%{xaxis.title.text}: %{x}<br><extra></extra><br>' +
        'Click on Points to view more',
    };
    return [
      {
        // mode: 'lines',
        showlegend: false,
        hovertemplate:
          '%{yaxis.title.text}: %{y:.2f}<br>' + '%{xaxis.title.text}: %{x}<br><extra></extra>',
        // line: { shape: 'spline', color: '#B8AB7E' },
        // type: 'scatter',
        // marker: {
        //   symbol: 'circle',
        //   size: 5,
        // },
        hoverlabel: {
          bgcolor: '#D3D3D3',
        },
        x: x,
        y: y,

        mode: 'lines',
        name: 'straight line graph',
        line: { shape: 'spline', color: '#B8AB7E' },
        type: 'scatter',
      },
      trace3,
      trace4,
      trace2,
      trace5,
      trace6,
    ];
  }

  var data = null;
  const regessionOptions = {
    editable: false,
    displaylogo: false,
    displayModeBar: false,
    scrollZoom: false,
    showLink: false,
    modeBarButtonsToRemove: [
      'sendDataToCloud',
      'zoom2d',
      'pan',
      'pan2d',
      'autoScale2d',
      'lasso2d',
      'autoScale2d',
      'resetScale2d',
      'toggleSpikelines',
      'dragmode',
    ],
  };
  var myPlot = document.getElementById('myDiv');

  var layout = {
    title: '',
    margin: {
      b: 80,
      l: 80,
      r: 30,
      t: 75,
    },
    xaxis: {
      rangeselector: selectorOptions,

      // , rangeslider: {}
      title: '<b>Campaign duration</b>',
      auto_generated_title: 'Campaign duration',
      zerolinecolor: 'black',
      zerolinewidth: 2,
    },
    yaxis: {
      fixedrange: true,
      title: `<b>${Y_AXIS_LABEL.current}</b>`,
      auto_generated_title: Y_AXIS_LABEL.current,
      zerolinecolor: 'black',
      zerolinewidth: 2,
    },
    layout: {
      dragmode: 'zoom',
    },
  };

  useEffect(() => {
    if (insightData.graphData) {
      data = prepData();
      // removeByAttr(layout.xaxis.rangeselector.buttons, 'label', 'YTD');

      Plotly.newPlot('myDiv', data, layout, regessionOptions, { responsive: true });
      Plotly.newPlot('myDivSs', data, layout, regessionOptions, { responsive: true });
      const dragLayer = document.getElementsByClassName('nsewdrag')[0];

      myPlot.on('plotly_hover', function (data) {
        dragLayer.style.cursor = 'pointer';
      });

      myPlot.on('plotly_unhover', function (data) {
        dragLayer.style.cursor = '';
      });

      setModalDetails(insightData?.optimizationSuggestions?.rawData);
      if (insightData?.non_negotiable_attributes.length > 10) {
        setShowNonAttributes(insightData?.non_negotiable_attributes);
      }
      updateNonAttributesLabel(insightData?.non_negotiable_attributes);

      myPlot.on('plotly_relayout', function (eventdata) {
        // var utc = new Date().toJSON().slice(0,10).replace(/-/g,'-');
        const currentDate = new Date();
        let date = new Date();
        date.setDate(date.getDate() - 7);
        const date1 = new Date(eventdata['xaxis.range[0]']);
        const date2 = new Date(eventdata['xaxis.range[1]']);
        let diff = parseInt((date2 - date1) / (1000 * 60 * 60 * 24), 10);
        if (diff < 8) {
          Plotly.relayout('myDiv', 'xaxis.range', [date, currentDate]);
        }
      });

      myPlot.on('plotly_click', function (e) {
        POINT_INDEX.current = e.points[0].pointIndex;
        setShowViewMoremodal(true);
      });
    }
  }, [insightData.analysisId, data]);

  const updateNonAttributesLabel = params => {
    let nonAttrArray = [];
    insightData.non_negotiable_attributes = [];
    params?.map(item => {
      let kpi = nonAttributes?.filter(kp => kp.sys_id === item)[0]?.attribute_metric;
      nonAttrArray.push(kpi);
    });
    //xyx.current = nonAttrArray
    if (nonAttrArray.length === 0) {
      nonAttrArray.push('None of the Attribute excluded');
    }

    return insightData?.non_negotiable_attributes?.push(nonAttrArray?.join(', '));
  };

  const updateDateFromEpoch = val => {
    if (insightData.graphData) {
      let d = new Date(val).toISOString();
      d = updateDateFormat(d);
      return d;
    }
  };

  const updateDateFormat = val => {
    const d = new Date(val);
    d.setUTCHours(0, 0, 0, 0);
    const yyyy = d.getFullYear();
    let mm = d.getMonth() + 1; // Months start at 0!
    let dd = d.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    // const date = d.getHours() + ':' + (d.getMinutes() < 10 ? ("0" + d.getMinutes()) : d.getMinutes()) + " " + d.toLocaleDateString();
    return dd + '.' + mm + '.' + yyyy;
  };

  const handleDeleteInsight = () => {
    setShowDeleteCampaignModal(true);
  };

  const handleOnCloseDeleteModal = () => {
    setShowDeleteCampaignModal(false);
  };

  const handleOnCancel = e => {
    e.preventDefault();
    setShowDeleteCampaignModal(false);
  };

  const handleOnConfirm = async () => {
    const payload = {
      deleteCampaign: false,
      analysisIds: [insightData?.analysisId],
    };
    deleteCampaign(payload);
  };

  async function deleteCampaign(payload) {
    try {
      const deleteRes = await AnalysisService.deleteCampaign(
        userAccessToken,
        username,
        campaignId,
        payload
      );
      const delResponse = deleteRes.data?.data;
      setShowDeleteCampaignModal(false);
      history.push('/optimization');
    } catch (error) {
      setShowDeleteCampaignModal(false);
    }
  }

  const renderModalContents = (item, size, level) => {
    const added =
      size === 'small'
        ? item.changes_from_last_fetch.change &&
          item.changes_from_last_fetch.change.added &&
          item.changes_from_last_fetch.change.added.length > 0
          ? [item.changes_from_last_fetch.change.added[0]]
          : []
        : item.changes_from_last_fetch.change.added;

    const edited =
      size === 'small'
        ? item.changes_from_last_fetch.change &&
          item.changes_from_last_fetch.change.edited &&
          item.changes_from_last_fetch.change.edited.length > 0
          ? [item.changes_from_last_fetch.change.edited[0]]
          : []
        : item.changes_from_last_fetch.change.edited;

    const removed =
      size === 'small'
        ? item.changes_from_last_fetch.change &&
          item.changes_from_last_fetch.change.removed &&
          item.changes_from_last_fetch.change.removed.length > 0
          ? [item.changes_from_last_fetch.change.removed[0]]
          : []
        : item.changes_from_last_fetch.change.removed;
    return (
      <React.Fragment>
        <p
          className={viewMoreData ? 'modal-h3-more-text' : 'modal-h3-text'}
          style={{ marginLeft: '30px' }}
          title={item.name}
        >
          <span style={{ fontFamily: 'Gotham Narrow Bold' }}>
            {capitalizeFirstLetter(level) + '  name/entityId : '}
          </span>{' '}
          {item.name} / {item.entityId}
        </p>
        {added.length > 0 && (
          <React.Fragment>
            <h5 className="to-text" style={{ marginLeft: '45px' }}>
              {t('rec.added')}:
            </h5>
            {added.map((item, index) =>
              // item.map((addedItems, index) => (
                <p style={{ marginLeft: '50px' }} key={index}>
                  {item[0]}: {item[1]}
                </p>
              // ))
            )}
          </React.Fragment>
        )}
        {edited.length > 0 && (
          <React.Fragment>
            <h5 style={{ marginLeft: '45px' }}>{t('rec.updated')}:</h5>
            {edited.map((editedItem, index) => (
              <p
                key={index}
                style={{ marginLeft: '50px' }}
                className={viewMoreData ? 'modal-h3-more-text' : 'modal-h3-text'}
                title={'From ' + editedItem[1] + 'to' + editedItem[2]}
              >
                {editedItem[0]} <span style={{ fontFamily: 'Gotham Narrow Bold' }}>{t('rec.from')}</span>{' '}
                <span className="from-text">{editedItem[1]}</span>{' '}
                <span style={{ fontFamily: 'Gotham Narrow Bold' }}>{t('report.client.reporting.to')}</span>{' '}
                <span className="to-text">{editedItem[2]}</span>
              </p>
            ))}
          </React.Fragment>
        )}
        {removed.length > 0 && (
          <React.Fragment>
            <h5 className="from-text" style={{ marginLeft: '45px' }}>
              {t('rec.deleted')}:
            </h5>
            {removed.map(item =>
              item.map((removedItem, index) => (
                <p style={{ marginLeft: '50px' }} index={index}>
                  {removedItem}
                </p>
              ))
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };

  const renderModal = (textData, size) => {
    const text =
      size === 'small'
        ? [textData[POINT_INDEX?.current || 0]?.sort(dynamicSort('level'))]
        : [textData[POINT_INDEX?.current || 0]?.sort(dynamicSort('level'))];
    return text?.map(textItem =>
      textItem?.map(entity => (
        <React.Fragment key={entity}>
          <React.Fragment>
            {entity?.items?.filter(entityItem => entityItem?.changes_from_last_fetch?.hasChanged)
              .length > 0 ? (
              <h4 style={{ marginLeft: '15px', marginTop: '10px' }}>
                {entity.level !== 'campaign' ? entity.level.toUpperCase() + 'S' : ''}
              </h4>
            ) : (
              ''
            )}
          </React.Fragment>

          {(size === 'small') & (entity.level !== 'campaign')
            ? [
                entity?.items?.filter(entityItem => entityItem?.changes_from_last_fetch?.hasChanged)[0],
              ].map(item => {
                return item ? renderModalContents(item, size, entity.level) : '';
              })
            : entity?.items
                ?.filter(entityItem => entityItem.changes_from_last_fetch.hasChanged)
                ?.map(item => {
                  return item ? renderModalContents(item, size, entity.level) : '';
                })}
        </React.Fragment>
      ))
    );
  };

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result = a[property] > b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  const viewMore = () => {
    if (viewMoreData) {
      setViewMoreData(false);
    } else {
      setViewMoreData(true);
    }
  };

  const decimalCount = num => {
    // Convert to String
    const numStr = String(num);
    // String Contains Decimal
    if (numStr.includes('.')) {
      const length = numStr.split('.')[1].length;
      num = num.toFixed(length);
      return num ? num.toLocaleString() : '';
    }
    // String Does Not Contain Decimal
    return num ? num.toLocaleString() : '';
  };

  const displayWarn = (attr) => {
    let result;
    let totatlSuggestedSettings = [];
    let msg = '';
    if(attr?.length) {
      let positions = ["facebook_positions","instagram_positions","audience_network_positions","messenger_positions"]
       result = attr?.filter(li => positions.includes(li?.campaign_attribute));
      result.sort((a, b) => a.rank - b.rank);
      const unique = [];
      result.map(x => unique.filter(a => a.campaign_attribute == x.campaign_attribute && x.rank > a.rank).length > 0 ? null : unique.push(x));
      result.forEach(li => {
        let splitData = li?.suggested_setting?.split(";");
        splitData.forEach(res => totatlSuggestedSettings.push(res))
      })
      if(totatlSuggestedSettings?.length < 6) {
        msg = t('perf.suggestion.settings.warn')
      }
    }
    return msg;
  }

  return (
    <DashboardContext.Provider value={{ dashData, setDashData }}>
      <div className="row no-gutters">
        <div className="no-gutters dash-left-wrapper">
          <DashboardHeader />
          <section>
            <div className='recommend-results'> 
            <div className="help-pdf-section">
              <HelpPdfDownload isLinearView={true} />
            </div>
            <div className="heading-btn-container">
              <button className="return-insights" onClick={() => handleBackClick()}>
                <i className="eva  eva-arrow-ios-back-outline"></i>
                {t('kpi.attr.button-back')}
              </button>
              <DownloadIcon className="download-icon" />
              <button className="download-snapshot" onClick={() => handleDownloadSSClick()}>
                <i className="eva eva-camera-outline"></i>
                {t('download.snapshot.button.label')}
              </button>
            </div>
            <div>
              <div className="campaign">
                <CampaignDetailsHeader campaignDetails={campaignDetails} />
              </div>
              <div className="recommendation-details">
                <div className="tab-box-container">
                  <span>{t('rec.kpi')}:</span>

                  <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={tabValue.toString()}>
                      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList
                          onChange={handleChange}
                          aria-label={t('insights.report.list.heading')}
                          variant="scrollable"
                          scrollButtons="auto"
                        >
                          {kpiList?.map((data, index) => {
                            return (
                              <Tab
                                key={(index + 1).toString()}
                                title={data[0]}
                                label={
                                  <React.Fragment>
                                    <span className="text tab-text">
                                      {data[0]} ({data[1]})
                                    </span>
                                  </React.Fragment>
                                }
                                value={(index + 1).toString()}
                              />
                            );
                          })}
                        </TabList>
                      </Box>
                    </TabContext>
                  </Box>
                </div>

                <div className="tab-date-container row">
                  <div style={{ fontSize: '15px', width: '7%' }}>{t('rec.report.date')}:</div>
                  <div style={{ width: '68%' }}>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                      <TabContext value={dateTabValue.toString()}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                          <TabList
                            onChange={handleDateChange}
                            aria-label={t('insights.report.list.heading')}
                            variant="scrollable"
                            scrollButtons="auto"
                          >
                            {kpiDateArray?.map((data, index) => {
                              return (
                                <Tab
                                  key={(index + 1).toString()}
                                  label={
                                    <React.Fragment>
                                      <span className="text capsule-value">{data}</span>
                                    </React.Fragment>
                                  }
                                  value={(index + 1).toString()}
                                />
                              );
                            })}
                          </TabList>
                        </Box>
                      </TabContext>
                    </Box>
                  </div>

                  <div
                    className="tabbed-buttom"
                    style={{ width: '25%', display: 'flex', justifyContent: 'flex-end' }}
                  >
                    <div>
                      <Button
                        type="button"
                        className="delete-button"
                        label={t('rec.delete.insights')}
                        handleClick={handleDeleteInsight}
                      ></Button>
                      <i className="eva eva-trash-2-outline trash-icon"></i>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="button-default kpi-button"
                        value={'Generate new KPI insights'}
                        onClick={handleGenerateKpikClick}
                      >
                        {t('rec.generate.insights')}
                        <i className="eva eva-plus-circle plus-icon"></i>
                      </button>
                    </div>
                  </div>
                </div>

                {insightData?.optimizationSuggestions?.rawData?.insights.length === 0 ? (
                  <div className="kpi-warn">
                    <i className="eva eva-alert-circle-outline warn-icon"></i>
                    <span className="warning">{t('recommendation.warning.message')}</span>
                  </div>
                ) : (
                  ''
                )}

                <div className="graph-view-container">
                  <div className="graph-view">
                    <div id="myDiv"></div>
                  </div>
                  <div className="graph-details">
                    <h5>{t('rec.about.graph')}</h5> <br></br>
                    <p>{t('details.attribute.graph.detail.desc.basic.continuous.desc1')}</p>
                    <br></br>
                    <p>{t('details.attribute.graph.detail.desc.basic.continuous.axisdata')}</p>
                    <p>
                      <span className="heading">{t('details.attribute.graph.detail.xaxis')}</span>
                      <span>{t('recommendation.xaxis.label')}</span>
                    </p>
                    <p>
                      <span className="heading">{t('details.attribute.graph.detail.yaxis')}</span>
                      <span>{t('recommendation.yaxis.label')}</span>
                    </p>
                    <p>{t('recommendation.graph.dotted.description1')}</p>
                    <p>{t('recommendation.graph.dotted.description2')}</p>
                    <p>
                      {' '}
                      <span className="heading">{t('recommendation.graph.update')}:</span>
                      <span>{t('recommendation.graph.pulldata')}</span>
                      <span className="heading">
                        {t('recommendation.next.lastpull')}:{' '}
                        {updateDateFromEpoch(insightData?.lastPull)} |{' '}
                        {t('recommendation.next.pull')}:{' '}
                        {updateDateFromEpoch(insightData?.nextPull)}
                      </span>
                    </p>
                  </div>
                </div>
                {insightData?.optimizationSuggestions?.rawData?.insights.length > 0 ? (
                  <div className="table-top-container">
                    <span>{t('optimisation.suggestions.for') +" " + Y_AXIS_LABEL.current}</span>
                    <button
                      type="button"
                      className="button-default view-insight-button "
                      label={t('recommendation.view.insight.details')}
                      onClick={() =>
                        handleViewClick(campaignDetails, Y_AXIS_LABEL.current, modalDetails)
                      }
                    >
                      {t('recommendation.view.insight.details')}
                    </button>
                    <i className="eva eva-arrow-circle-right icon-forward"></i>
                  </div>
                ) : (
                  ''
                )}

                {insightData?.optimizationSuggestions?.rawData?.insights.length > 0 ? (
                  <div className="selected-report-attribute-details--table">
                    <table>
                      <thead>
                        <tr>
                          <th scope="col">{t('detail.attribute.listing.thead.rank')}</th>
                          {/* <th scope="col">{'Category'}</th> */}
                          <th scope="col">{t('rec.col.attribute')}</th>
                          <th scope="col">{t('rec.col.current.setting')}</th>
                          <th scope="col">{t('rec.col.suggest.setting')}</th>
                          <th scope="col">{t('rec.col.predicted.lifetime')}</th>
                          <th scope="col">{t('rec.predict.percent')}</th>
                        </tr>
                      </thead>

                      <tbody>
                        {insightData?.optimizationSuggestions?.rawData?.extened_suggestions?.map(
                          (row, index) => {
                            return (
                              <tr className="form__table-row" key={index}>
                                <td>
                                  <span
                                    className={`rank ${
                                      row.rank < 3
                                        ? 'a'
                                        : row.rank < 8
                                        ? 'b'
                                        : row.rank < 11
                                        ? 'c'
                                        : row.rank < 13
                                        ? 'd'
                                        : row.rank < 16
                                        ? 'e'
                                        : 'f'
                                    }`}
                                  >
                                    {row.rank}
                                  </span>
                                </td>
                                {/* <td>{row.category}</td> */}
                                <td>
                                  <span className='add_warn' title={row.title}>{row.title}</span>
                                </td>
                                <td>
                                  <span title={row.current_setting}>{row.current_setting}</span>
                                </td>
                                <td>
                                  <span title={row.suggested_setting}>{row.suggested_setting}</span>
                                </td>
                                <td>
                                  <span>{decimalCount(row.predicted_impact_on_KPI)}</span>
                                </td>
                                <td>
                                  <span>{row.predicted_impact_percent + '%'}</span>
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  ''
                )}
                {displayWarn(insightData?.optimizationSuggestions?.rawData?.extened_suggestions) !== '' && <div className='warn-msg'>{displayWarn(insightData?.optimizationSuggestions?.rawData?.extened_suggestions)}</div>}
                <div className="about-these-recommen">
                  {insightData?.optimizationSuggestions?.rawData?.insights.length > 0 ? (
                    <div className="about-this-graph">
                      <h4>{t('recommendation.about.these.recommendations')}</h4>
                      <p>{t('recommendation.about.these.recommendations.desc1')} </p>

                      <p> {t('recommendation.about.these.recommendations.desc2')}</p>
                    </div>
                  ) : (
                    ''
                  )}

                  <p className="non-negotiables">
                    <span className="heading">{t('recommendation.non.negotiables')}:</span>
                    <label>
                      {' '}
                      {t('recommendation.non.negotiables.desc1')}:
                      <span title={insightData?.non_negotiable_attributes}>
                        {insightData?.non_negotiable_attributes}
                      </span>
                    </label>
                  </p>
                  {insightData?.optimizationSuggestions?.rawData?.insights.length > 0 ? (
                    <p>
                      <span>{t('recommendation.non.negotiables.desc2')}</span>
                    </p>
                  ) : (
                    ''
                  )}

                  {insightData?.optimizationSuggestions?.rawData?.insights.length > 0 ? (
                    <p>
                      <span> {t('recommendation.non.negotiables.desc3')} </span>
                      <span className="heading"> {t('recommendation.non.negotiables.desc4')}</span>
                    </p>
                  ) : (
                    ''
                  )}

                  {insightData?.optimizationSuggestions?.rawData?.insights.length > 0 ? (
                    <p>
                      {t('recommendation.non.negotiables.desc5')}{' '}
                      <span className="heading"> {t('recommendation.non.negotiables.desc6')} </span>
                      {t('recommendation.non.negotiables.desc7')}
                    </p>
                  ) : (
                    ''
                  )}
                  {insightData?.optimizationSuggestions?.rawData?.insights.length > 0 ? (
                    <p>
                      <span className="heading"> {t('recommendation.non.negotiables.desc8')}</span>
                      <span>{t('recommendation.non.negotiables.desc9')}</span>
                    </p>
                  ) : (
                    ''
                  )}
                </div>
                <div className="bottom-button">
                  <Button
                    type="button"
                    className="back-button"
                    label={t('back.campaign.list')}
                    handleClick={handleBackClick}
                  ></Button>
                  <i className="eva eva-arrow-back-outline icon-back"></i>
                  <Button
                    type="button"
                    className="bm-button"
                    label={t('meta.business.suite')}
                    handleClick={goToFbSuite}
                  ></Button>
                  <i className="eva eva-external-link-outline icon-external"></i>
                </div>
                <div className="report-delete">
                  <ModalWindow
                    className="fqa-modal--showanswer"
                    isOpen={showDeleteCampaignModal}
                    onRequestClose={handleOnCloseDeleteModal}
                    heading={t('reportTable.campaign.delete.heading')}
                    ariaHideApp={false}
                  >
                    <p className="fqa-model-showanswer--message message-font">
                      {t('reportTable.delete.insight.subHeading')}
                    </p>
                    <div className="fqa-model-pa--actions">
                      <ActionLink
                        anchor={true}
                        value={t('reportTable.campaign.delete.cancel')}
                        handleClick={handleOnCancel}
                      />
                      <Button
                        className="fqa-model-pa--actions-confirm delete-button"
                        label={t('reportTable.campaign.delete')}
                        handleClick={handleOnConfirm}
                      />
                    </div>
                  </ModalWindow>
                </div>
              </div>
            </div>
            {recommendationModalView && (
              <RecommendationDetailsModal
                insightDetails={recommendationModalView}
                handleModalBackClick={handleModalBackClick}
              />
            )}



            <ModalWindow
              className={viewMoreData ? 'fqa-modal--view-more' : 'fqa-modal--showanswer'}
              isOpen={showViewMoremodal}
              onRequestClose={handleOnCloseModal}
              heading={t('metadata.changes')}
            >
              <React.Fragment>
                <h4 className={viewMoreData ? 'modal-h3-more-text' : 'modal-h3-text'}>
                  {t('rec.campaign')}:{' '}
                  <span
                    
                    title={campaignDetails?.name}
                  >
                    {campaignDetails?.name}
                  </span>{' '}
                </h4>
              </React.Fragment>
              <React.Fragment>
                {insightData?.graphData?.metaDataChanges
                  ? viewMoreData
                    ? renderModal(insightData?.graphData?.metaDataChanges?.text, 'large')
                    : renderModal(insightData?.graphData?.metaDataChanges?.text, 'small')
                  : ''}
              </React.Fragment>

              <div className="fqa-model-pa--actions">
                <ActionLink
                  anchor={true}
                  target={false}
                  value={viewMoreData ? t('rec.view.less') : t('rec.view.more')}
                  handleClick={viewMore}
                />

                <Button
                  className="fqa-model-pa--actions-confirm"
                  label={t('rec.go.back')}
                  handleClick={e => {
                    e.preventDefault();
                    setShowViewMoremodal(false);
                    setViewMoreData(false);
                  }}
                />
              </div>
            </ModalWindow>


            <div id="snapshot-result-container">
              <div className="campaign">
                <CampaignDetailsHeader campaignDetails={campaignDetails} />
              </div>
              <div className="recommendation-details">
                <div className="tab-box-container">
                  <span>{t('rec.kpi')}:</span>

                  <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={tabValue.toString()}>
                      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList
                          onChange={handleChange}
                          aria-label={t('insights.report.list.heading')}
                          variant="scrollable"
                          scrollButtons="auto"
                        >
                          {kpiList?.map((data, index) => {
                            return (
                              <Tab
                                key={(index + 1).toString()}
                                title={data[0]}
                                label={
                                  <React.Fragment>
                                    <span className="text tab-text">
                                      {data[0]} ({data[1]})
                                    </span>
                                  </React.Fragment>
                                }
                                value={(index + 1).toString()}
                              />
                            );
                          })}
                        </TabList>
                      </Box>
                    </TabContext>
                  </Box>
                </div>

                <div className="tab-date-container row">
                  <div style={{ fontSize: '15px', width: '7%' }}>{t('rec.report.date')}:</div>
                  <div style={{ width: '68%' }}>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                      <TabContext value={dateTabValue.toString()}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                          <TabList
                            onChange={handleDateChange}
                            aria-label={t('insights.report.list.heading')}
                            variant="scrollable"
                            scrollButtons="auto"
                          >
                            {kpiDateArray?.map((data, index) => {
                              return (
                                <Tab
                                  key={(index + 1).toString()}
                                  label={
                                    <React.Fragment>
                                      <span className="text capsule-value">{data}</span>
                                    </React.Fragment>
                                  }
                                  value={(index + 1).toString()}
                                />
                              );
                            })}
                          </TabList>
                        </Box>
                      </TabContext>
                    </Box>
                  </div>

                  <div 
                    className="tabbed-buttom"
                    style={{ width: '25%', display: 'flex', justifyContent: 'flex-end', visibility: 'hidden'  }}
                  >
                    <div>
                      <Button
                        type="button"
                        className="delete-button"
                        label={t('rec.delete.insights')}
                        handleClick={handleDeleteInsight}
                      ></Button>
                      <i className="eva eva-trash-2-outline trash-icon"></i>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="button-default kpi-button"
                        value={'Generate new KPI insights'}
                        onClick={handleGenerateKpikClick}
                      >
                        {t('rec.generate.insights')}
                        <i className="eva eva-plus-circle plus-icon"></i>
                      </button>
                    </div>
                  </div>
                </div>

                {insightData?.optimizationSuggestions?.rawData?.insights.length === 0 ? (
                  <div className="kpi-warn">
                    <i className="eva eva-alert-circle-outline warn-icon"></i>
                    <span className="warning">{t('recommendation.warning.message')}</span>
                  </div>
                ) : (
                  ''
                )}

                <div className="graph-view-container">
                  <div className="graph-view">
                    <div id="myDivSs"></div>
                  </div>
                  <div className="graph-details">
                    <h5>{t('rec.about.graph')}</h5> <br></br>
                    <p>{t('details.attribute.graph.detail.desc.basic.continuous.desc1')}</p>
                    <br></br>
                    <p>{t('details.attribute.graph.detail.desc.basic.continuous.axisdata')}</p>
                    <p>
                      <span className="heading">{t('details.attribute.graph.detail.xaxis')}</span>
                      <span>{t('recommendation.xaxis.label')}</span>
                    </p>
                    <p>
                      <span className="heading">{t('details.attribute.graph.detail.yaxis')}</span>
                      <span>{t('recommendation.yaxis.label')}</span>
                    </p>
                    <p>{t('recommendation.graph.dotted.description1')}</p>
                    <p>{t('recommendation.graph.dotted.description2')}</p>
                    <p>
                      {' '}
                      <span className="heading">{t('recommendation.graph.update')}:</span>
                      <span>{t('recommendation.graph.pulldata')}</span>
                      <span className="heading">
                        {t('recommendation.next.lastpull')}:{' '}
                        {updateDateFromEpoch(insightData?.lastPull)} |{' '}
                        {t('recommendation.next.pull')}:{' '}
                        {updateDateFromEpoch(insightData?.nextPull)}
                      </span>
                    </p>
                  </div>
                </div>
                {insightData?.optimizationSuggestions?.rawData?.insights.length > 0 ? (
                  <div className="table-top-container">
                    <span>{t('optimisation.suggestions.for')+" " + Y_AXIS_LABEL.current}</span>
                    {/* <button
                      type="button"
                      className="button-default view-insight-button "
                      label={t('recommendation.view.insight.details')}
                      onClick={() =>
                        handleViewClick(campaignDetails, Y_AXIS_LABEL.current, modalDetails)
                      }
                    >
                      {t('recommendation.view.insight.details')}
                    </button>
                    <i className="eva eva-arrow-circle-right icon-forward"></i> */}
                  </div>
                ) : (
                  ''
                )}

                {insightData?.optimizationSuggestions?.rawData?.insights.length > 0 ? (
                  <div className="selected-report-attribute-details--table">
                    <table>
                      <thead>
                        <tr>
                          <th scope="col">{t('detail.attribute.listing.thead.rank')}</th>
                          {/* <th scope="col">{'Category'}</th> */}
                          <th scope="col">{t('rec.col.attribute')}</th>
                          <th scope="col">{t('rec.col.current.setting')}</th>
                          <th scope="col">{t('rec.col.suggest.setting')}</th>
                          <th scope="col">{t('rec.col.predicted.lifetime')}</th>
                          <th scope="col">{t('rec.predict.percent')}</th>
                        </tr>
                      </thead>

                      <tbody>
                        {insightData?.optimizationSuggestions?.rawData?.extened_suggestions?.map(
                          (row, index) => {
                            return (
                              <tr className="form__table-row" key={index}>
                                <td>
                                  <span
                                    className={`rank ${
                                      row.rank < 3
                                        ? 'a'
                                        : row.rank < 8
                                        ? 'b'
                                        : row.rank < 11
                                        ? 'c'
                                        : row.rank < 13
                                        ? 'd'
                                        : row.rank < 16
                                        ? 'e'
                                        : 'f'
                                    }`}
                                  >
                                    {row.rank}
                                  </span>
                                </td>
                                {/* <td>{row.category}</td> */}
                                <td>
                                <span className='add_warn' title={row.title}>{row.title}</span>
                                </td>
                                <td>
                                  <span title={row.current_setting}>{row.current_setting}</span>
                                </td>
                                <td>
                                  <span title={row.suggested_setting}>{row.suggested_setting}</span>
                                </td>
                                <td>
                                  <span>{decimalCount(row.predicted_impact_on_KPI)}</span>
                                </td>
                                <td>
                                  <span>{row.predicted_impact_percent + '%'}</span>
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  ''
                )}
               {displayWarn(insightData?.optimizationSuggestions?.rawData?.extened_suggestions) !== '' && <div className='warn-msg'>&nbsp;{displayWarn(insightData?.optimizationSuggestions?.rawData?.extened_suggestions)}</div>}
                <div className="about-these-recommen">
                  {insightData?.optimizationSuggestions?.rawData?.insights.length > 0 ? (
                    <div className="about-this-graph">
                      <h4>{t('recommendation.about.these.recommendations')}</h4>
                      <p>{t('recommendation.about.these.recommendations.desc1')} </p>

                      <p> {t('recommendation.about.these.recommendations.desc2')}</p>
                    </div>
                  ) : (
                    ''
                  )}

                  <p className="non-negotiables">
                    <span className="heading">{t('recommendation.non.negotiables')}:</span>
                    <label>
                      {' '}
                      {t('recommendation.non.negotiables.desc1')}:
                      <span title={insightData?.non_negotiable_attributes}>
                        {insightData?.non_negotiable_attributes}
                      </span>
                    </label>
                  </p>
                  {insightData?.optimizationSuggestions?.rawData?.insights.length > 0 ? (
                    <p>
                      <span>{t('recommendation.non.negotiables.desc2')}</span>
                    </p>
                  ) : (
                    ''
                  )}

                  {insightData?.optimizationSuggestions?.rawData?.insights.length > 0 ? (
                    <p>
                      <span> {t('recommendation.non.negotiables.desc3')} </span>
                      <span className="heading"> {t('recommendation.non.negotiables.desc4')}</span>
                    </p>
                  ) : (
                    ''
                  )}

                  {insightData?.optimizationSuggestions?.rawData?.insights.length > 0 ? (
                    <p>
                      {t('recommendation.non.negotiables.desc5')}{' '}
                      <span className="heading"> {t('recommendation.non.negotiables.desc6')} </span>
                      {t('recommendation.non.negotiables.desc7')}
                    </p>
                  ) : (
                    ''
                  )}
                  {insightData?.optimizationSuggestions?.rawData?.insights.length > 0 ? (
                    <p>
                      <span className="heading"> {t('recommendation.non.negotiables.desc8')}</span>
                      <span>{t('recommendation.non.negotiables.desc9')}</span>
                    </p>
                  ) : (
                    ''
                  )}
                </div>
                {/* <div className="bottom-button">
                  <Button
                    type="button"
                    className="back-button"
                    label={'Back To Campaign List'}
                    handleClick={handleBackClick}
                  ></Button>
                  <i className="eva eva-arrow-back-outline icon-back"></i>
                  <Button
                    type="button"
                    className="bm-button"
                    label={'Go to Meta Business Suite'}
                    handleClick={goToFbSuite}
                  ></Button>
                  <i className="eva eva-external-link-outline icon-external"></i>
                </div> */}
                <div className="report-delete">
                  <ModalWindow
                    className="fqa-modal--showanswer"
                    isOpen={showDeleteCampaignModal}
                    onRequestClose={handleOnCloseDeleteModal}
                    heading={t('reportTable.campaign.delete.heading')}
                    ariaHideApp={false}
                  >
                    <p className="fqa-model-showanswer--message message-font">
                      {t('reportTable.delete.insight.subHeading')}
                    </p>
                    <div className="fqa-model-pa--actions">
                      <ActionLink
                        anchor={true}
                        value={t('reportTable.campaign.delete.cancel')}
                        handleClick={handleOnCancel}
                      />
                      <Button
                        className="fqa-model-pa--actions-confirm delete-button"
                        label={t('reportTable.campaign.delete')}
                        handleClick={handleOnConfirm}
                      />
                    </div>
                  </ModalWindow>
                </div>
              </div>
            </div>
            </div>
          </section>
          <DashContentFooter />
        </div>
      </div>
    </DashboardContext.Provider>
  );
};

export default RecommendationResults;
